import { Injectable } from '@angular/core';
import { AbstractWidgetService } from '../../services/abstract-widget.service';
import { DocumentEditorActionsType, TemplateActionArgs, UiWidget } from '@pt/pt-models';
import { WidgetActionsUtils } from '../../utils';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GetChapterResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';

@Injectable({
  providedIn: 'root'
})
export class WidgetCheckboxService extends AbstractWidgetService {


  constructor(public store: Store, public translateService: TranslateService) {
    super(store, translateService);
  }


  /**
   * TRIGGER
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   * @param queryResponse
   */
  execTrigger(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    if (widget?.version !== null && widget?.version !== undefined) {
      switch (widget.version) {
        case 0:
          return this.execTriggerV0(context, widgets, widget, action, args, queryResponse);
        default:
          this.invalidWidgetVersion(widget);
          return null;
      }
    }
    return null;
  }

  /**
   * INITIALIZATION
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   * @param queryResponse
   */
  initialization(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    this.unsupportedInitialization(widget);
    return null;
  }

  private execTriggerV0(context: GetChapterResponse, widgets: UiWidget[], widget: UiWidget, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    switch (action) {
      case DocumentEditorActionsType.UPSERT_VALUE:
        this.validWidgetAction(widget, action);
        return this.upsertValue(widget, widgets, args);

      default:
        this.invalidWidgetAction(widget, action);
    }
    return null;
  }

  /**
   * @param widget
   * @param widgets
   * @param args
   * @private
   */
  private upsertValue(widget: UiWidget, widgets: UiWidget[], args: TemplateActionArgs) {
    const currentWidget = JSON.parse(JSON.stringify(widget));
    currentWidget.value = WidgetActionsUtils.execJsonPath(args?.jsonPath?.source, widgets);
    return currentWidget;
  }

}
